import moment from 'moment';
import _ from 'lodash';
import code from '../constants/code';
import status from '../constants/status';
import assets from '../data/authorityData';

export default (Vue) => {
  Vue.filter('date', (timestamp) => {
    if (!timestamp || timestamp === '-') return '-';
    return moment(timestamp).format('YYYY-MM-DD');
  });

  Vue.filter('dateKOR', (timestamp) => {
    if (!timestamp || timestamp === '-') return '-';
    return moment(timestamp).format('YYYY년 M월 D일');
  });

  Vue.filter('time', (timestamp) => {
    if (!timestamp || timestamp === '-') return '-';
    return moment(timestamp).format('YYYY-MM-DD HH:mm');
  });

  Vue.filter('dateKor', (timestamp) => {
    if (!timestamp || timestamp === '-') return '-';
    return moment(timestamp).format('YYYY년 MM월 DD일');
  });

  Vue.filter('payment', c => (status[c] && status[c].pay) || '-');

  Vue.filter('level', c => code.level[c] || '-');

  Vue.filter('type', type => code.type[type] || '-');

  Vue.filter('charge', type => code.charge[type] || '-');

  Vue.filter('qnaCategory', type => code.qnaCategory[type] || '-');

  Vue.filter('faqCategory', type => code.faqCategory[type] || '-');

  Vue.filter('recheck', type => code.recheck[type] || '신규심사');

  Vue.filter('changeResult', yn => (!yn ? '-' : yn === 'Y' ? '승인' : '불가'));

  Vue.filter('csCategory', type => code.csCategory[type] || '-');

  Vue.filter('infoCategory', type => code.infoCategory[type] || '-');

  Vue.filter('authorityName', c => assets.name[c] || '-');

  Vue.filter('comma', x => (x || x === 0 ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-'));

  Vue.filter('companyNo', v => ((v && v.length === 10) ? v.replace(/^(\d{3})(\d{2})(\d{5})$/, '$1-$2-$3') : v));

  Vue.filter('agg', (list, key) => (list ? _.map(list, item => item[key]).join(',') : '-'));

  Vue.filter('specArray', org => (!org ? '-' : org.replace(/@@@/g, ', ').replace(/!!!/, '[추가]')));

  Vue.filter('judgeResult', yn => (
    !yn ? '-'
      : yn === 'E' ? '면제'
        : yn === 'Y' ? '적합'
          : '부적합'));

  Vue.filter('examResult', yn => (!yn ? '-' : yn === 'Y' ? '합격' : '불합격'));

  Vue.filter('core', yn => (!yn ? '-' : yn === 'Y' ? '핵심' : '일반'));

  Vue.filter('recheckType', yn => (!yn ? '' : { Y: '(확인심사)', R: '(재심사)' }[yn]));
};



// WEBPACK FOOTER //
// ./src/filters/index.js